export default __webpack_public_path__ + "static/media/detail_big_11_6.0888dea8.jpg";